export default {"src":"/_next/static/media/section8-img.6c21773a.svg","height":396,"width":662,"blurWidth":0,"blurHeight":0};